import { render, staticRenderFns } from "./talentPool.vue?vue&type=template&id=6cbd8004&scoped=true&"
import script from "./talentPool.vue?vue&type=script&lang=js&"
export * from "./talentPool.vue?vue&type=script&lang=js&"
import style0 from "./talentPool.vue?vue&type=style&index=0&id=6cbd8004&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbd8004",
  null
  
)

export default component.exports